import React from "react";
import {useNavigate} from "react-router-dom";
import NiceButton from "../pictures/NiceButton";

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div style={{textAlign: "center", padding: "40px"}}>
            <h1>404</h1>
            <h2>Page not found</h2>
            <NiceButton onClick={() => navigate("/")} text={'Go home'}/>
        </div>
    );
};

export default NotFoundPage;